// Shared mic-on-time math for the Heartbeats page. User-hours are the
// area under the concurrency curve: each sample is a count of users
// mic-on at that instant, held for one step. Estimates are biased
// slightly high — dirty stops (crashes, kills) keep a user counted for
// up to the 15-minute freshness window after they actually stopped;
// clean stops drop out immediately.

import { STACK_ORDER } from './cohorts'

export const HOUR = 3600

export const integrateHours = (history, fromTs = 0) => {
  let seconds = 0
  history.series.forEach(({ points }) => {
    points.forEach(([ts, value]) => {
      if (ts >= fromTs) seconds += value * history.step_seconds
    })
  })
  return seconds / HOUR
}

// Running per-persona user-hours in stack order (bottom band first),
// aligned on the union timestamp grid — ECharts stacks series by data
// index, so every persona must emit a point at every timestamp for the
// stack to line up.
export const cumulativeSeries = (history) => {
  const tsSet = new Set()
  history.series.forEach(({ points }) =>
    points.forEach(([ts]) => tsSet.add(ts))
  )
  const timestamps = [...tsSet].sort((a, b) => a - b)

  return STACK_ORDER.map((persona) => {
    const byTs = new Map()
    history.series.forEach((entry) => {
      if (!persona.match(entry.labels || {})) return
      entry.points.forEach(([ts, value]) => {
        byTs.set(ts, (byTs.get(ts) || 0) + value)
      })
    })
    let hours = 0
    const points = timestamps.map((ts) => {
      hours += ((byTs.get(ts) || 0) * history.step_seconds) / HOUR
      return [ts * 1000, hours]
    })
    return { ...persona, hours, points }
  })
}

// Per-persona user-hours within [fromTs, toTs), keyed by persona key.
export const personaHours = (history, fromTs = 0, toTs = Infinity) => {
  const hours = {}
  STACK_ORDER.forEach(({ key }) => {
    hours[key] = 0
  })
  history.series.forEach((entry) => {
    const persona = STACK_ORDER.find(({ match }) => match(entry.labels || {}))
    if (!persona) return
    entry.points.forEach(([ts, value]) => {
      if (ts >= fromTs && ts < toTs) {
        hours[persona.key] += (value * history.step_seconds) / HOUR
      }
    })
  })
  return hours
}

export const fmtHours = (hours) => {
  if (hours < 1) return `${Math.round(hours * 60)} min`
  if (hours < 10) return `${hours.toFixed(1)}h`
  return `${Math.round(hours)}h`
}
